import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
import axios from "axios";

const PayProfileService = {
    getAllPayProfile(obj) {
        return httpClient.post(endPoints.getPayProfile, obj);
    },
    updatePayProfile(obj) {
        return httpClient.post(endPoints.updatePayProfile, obj);
    },
};

export default PayProfileService;



// WEBPACK FOOTER //
// ./src/service/PayProfileService.js